import { useLocale } from 'containers/App/LocaleContext';
import type { JSX, ReactNode } from 'react';

type DropdownMenuProps<TOption> = {
  emptyDropdownContent?: ReactNode;
  options: TOption[] | null;
  onSelect: (option: TOption) => void;
  renderOption: (option: TOption) => ReactNode;
  title?: ReactNode;
};

export const TypeaheadDropdownContent = <TOption,>(
  props: DropdownMenuProps<TOption>,
): JSX.Element => {
  const {
    generic: {
      components: { typeahead: typeaheadMsg },
    },
  } = useLocale();

  return props.options?.length ? (
    <>
      {props.title && (
        <div className='px-2 py-3 font-semibold'>{props.title}</div>
      )}
      {props.options.map((option, index) => (
        <div
          // biome-ignore lint/suspicious/noArrayIndexKey: no better index there
          key={index}
          className='cursor-pointer px-2 py-3 hover:bg-gray-50'
          onClick={() => {
            props.onSelect(option);
          }}
        >
          {props.renderOption(option)}
        </div>
      ))}
    </>
  ) : (
    <div className='px-2 py-3'>
      {props.emptyDropdownContent ??
        (props.options === null
          ? typeaheadMsg.typeToSearch
          : typeaheadMsg.noResults)}
    </div>
  );
};
